import React, { Component } from 'react';
import './Noticias.css';
import AddNoticia from '../AddNoticia/AddNoticia';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Link from 'react-router-dom/Link';
import axios from 'axios';
import NoticiaCard from '../NoticiaCard/NoticiaCard';
import { BASE_HOST_URL } from '../../config';

class Noticias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      news: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await axios.get(`${BASE_HOST_URL}/api/v1/news`);
      this.setState({ news: data });
    } catch (err) {
      console.log(err);
    }
  }

  editNew(id) {
    this.props.history.push(`/editNew/${id}`);
  }

  delete(index) {
    console.log('delete: ', index);
    const news = this.state.news.splice(index, 1);
    console.log('news: ', news);
    this.setState({ news });
  }

  render() {
    return (
      <div className="noticiasWrapper">
        <div className="subHeaderWrapper">
          <Link to="/addNew">
            <button>+ AFEGIR NOTICIA</button>
          </Link>
        </div>
        <div className="">
          {
            this.state.news.map((noticia, index) => (
              <NoticiaCard
                key={index}
                noticia={noticia.state}
                delete={() => this.delete(index)}
                edit={(id) => this.editNew(id)}
              />
            ))
          }
        </div>
      </div>
    );
  }
}

export default Noticias;



// WEBPACK FOOTER //
// ./src/components/Noticias/Noticias.js